(ns frontend.ui.page.lp-portal.loading-page.controller
  (:require
   [herb.core :as h]
   [frontend.ui.page.lp-report-editor.style :as style]
   [common.localization :as loc]))

(defn route-error
  [{:keys [handler path-params query-params] :as view-args}]
  (js/console.log "ERROR ROUTE " view-args)
  [:div
   {:class (h/<class style/page-container-loading)}
   [:img
    {:src   "/img/Spinning-arrow.gif"
     :class (h/<class style/img)}]

   [:span (loc/tr :loading)]])
